/**
 * The markup of an icon of the sprite dist/icons.svg, as the templates print it through
 * $this->icon(): an inline <svg class="eg-icon"> with a <use> of the symbol eg-<name>. A
 * script which builds markup takes its icons from here, so the page draws every icon the
 * same way. The address of the sprite comes from window.EventGalleryAssets, which
 * MediaLoader writes into the page; without it the <use> points at a symbol of the page,
 * which the style guide fixture holds.
 *
 * @param {string} name the name of the glyph, e.g. cart, cart-plus, close, share
 * @param {string} [classes] further classes of the svg, e.g. eg-icon--sm
 * @param {string} [label] a name for a screen reader when the icon stands alone; without
 *                         one the icon is hidden from it, because the text next to it names
 *                         the control
 * @returns {string}
 */
export function icon(name, classes = '', label = '') {
    const href = spriteUrl() + '#eg-' + name;
    const accessible = label
        ? ' role="img" aria-label="' + escape(label) + '"'
        : ' aria-hidden="true"';
    return '<svg class="eg-icon' + (classes ? ' ' + classes : '') + '"' + accessible + ' focusable="false"><use href="' + escape(href) + '"></use></svg>';
}

/**
 * Points the <use> of an icon at another glyph of the sprite - the cart control of a
 * thumbnail switches between "add" and "in the cart".
 *
 * @param {Element|null} svg the <svg class="eg-icon"> element
 * @param {string} name the name of the glyph
 */
export function swapIcon(svg, name) {
    const use = svg ? svg.querySelector('use') : null;
    if (use) {
        use.setAttribute('href', spriteUrl() + '#eg-' + name);
    }
}

export function spriteUrl() {
    const assets = typeof window !== 'undefined' ? window.EventGalleryAssets : undefined;
    return assets && assets.icons ? String(assets.icons) : '';
}

function escape(value) {
    return String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
}
